import { Locataire } from "../../model/Model";
import { del, get, post, put } from "../api";

export async function getLocataires(): Promise<Locataire[]> {
    try {
        const response = await get('/v1/locataires');
        return response.data?.data || [];
    } catch (error) {
        console.error('Erreur lors de la récupération des locataires:', error);
        return [];
    }
}

export async function ajouterLocataire(locataire: Locataire): Promise<Locataire> {
    try {
        const response = await post('/v1/locataires', locataire);
        return response.data;
    } catch (error) {
        console.error('Erreur lors de l\'ajout du locataire:', error);
        throw error;
    }
}

export async function modifierLocataire(locataire: Locataire): Promise<Locataire> {
    try {
        const response = await put('/v1/locataires', locataire);
        return response.data?.data;
    } catch (error) {
        console.error('Erreur lors de la modification du locataire:', error);
        throw error;
    }
}

export async function supprimerLocataire(locataireId: number): Promise<any> {
    try {
        const response = await del(`/v1/locataires/${locataireId}`);
        return response.data?.data;
    } catch (error) {
        console.error('Erreur lors de la suppression du locataire:', error);
        throw error;
    }
}

export async function getLocataireById(id: number): Promise<Locataire | null> {
    try {
        const response = await get(`/v1/locataires/${id}`);
        return response.data?.data;
    } catch (error) {
        console.error(`Erreur lors de la récupération du locataire avec l'id ${id}:`, error);
        return null;
    }
}